<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M8.6 21.0977V12.931H0.5V8.26432H8.6V0.0976562H13.4V8.26432H21.5V12.931H13.4V21.0977H8.6Z"
      fill="#212121"
    />
  </svg>
</template>
